import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueSession from 'vue-session'
import { firestorePlugin } from 'vuefire'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import firebase from "firebase/app";


import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select'


Vue.use(VueSession)
Vue.use(firestorePlugin)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false
Vue.component('v-select', vSelect)

const firebaseConfig = {
  apiKey: "AIzaSyAG4ub4RPSGArL4DrOzPvuYOCoLOKvZHig",
  authDomain: "diazvelizexpress.firebaseapp.com",
  databaseURL: "https://diazvelizexpress-default-rtdb.firebaseio.com",
  projectId: "diazvelizexpress",
  storageBucket: "diazvelizexpress.appspot.com",
  messagingSenderId: "287052230881",
  appId: "1:287052230881:web:10ebb442697e24e21507a0"
};


firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

